var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11957",
    "data-name": "Group 11957",
    transform: "translate(-1665 -651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43926",
    "data-name": "Path 43926",
    d: "M21.5,0A21.5,21.5,0,1,1,0,21.5,21.5,21.5,0,0,1,21.5,0Z",
    transform: "translate(1665 651)",
    fill: "#ef7b18"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11937",
    "data-name": "Group 11937",
    transform: "translate(205.266 -906.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44591",
    "data-name": "Path 44591",
    d: "M71.508,80.885H63.39c-1.05,0-1.411-.356-1.409-1.4,0-2.2-.033-4.4.032-6.6a7.29,7.29,0,0,1,6.519-6.813,45.756,45.756,0,0,1,6,0,7.273,7.273,0,0,1,6.545,6.883c.066,2.246.031,4.494.026,6.742,0,.8-.434,1.191-1.291,1.192q-4.151,0-8.3,0",
    transform: "translate(1409.418 1511.774)",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44595",
    "data-name": "Path 44595",
    d: "M89.318,10.643a5.321,5.321,0,1,1,5.3-5.352,5.314,5.314,0,0,1-5.3,5.352",
    transform: "translate(1391.658 1564.999)",
    fill: "#151515"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconDark);
export default __webpack_public_path__ + "static/media/user-icon-dark.f86f7a737a8282dde0ced27b6aa23c4e.svg";
export { ForwardRef as ReactComponent };